















































import { Vue, Component, Prop, Ref, Watch } from "vue-property-decorator";
//import ScoutingMap from "@/components/Scouting/Map.vue";
import ScoutingMap from "@/components/Scouting/Map.vue";
import { currentScoutingStore } from "@/store/typed";
import StoreSubscriber from "@/utils/StoreSubscriber";
import { ScoutingPlace } from "../../models";
import { GOOGLE_MAPS_API_KEY } from "../../utils/Constants";

import ScoutingDetails from "@/components/Scouting/Details.vue";
import ScoutingPlaceDetails from "@/components/ScoutingPlace/Details.vue";
import ScoutingAreaDetails from "@/components/ScoutingArea/Details.vue";
import { NavigationGuardNext, Route } from "vue-router";
import ScoutingArea from "@/models/ScoutingArea";

declare global {
  interface Window {
    google?: any;
  }
}

Component.registerHooks(["beforeRouteEnter", "beforeRouteUpdate"]);

@Component({
  components: {
    ScoutingMap,
    ScoutingDetails,
    ScoutingPlaceDetails,
    ScoutingAreaDetails,
  },
})
export default class Map extends Vue {
  private map: any = null;
  private googleMapsLoaded = false;
  private detailsType = "";
  private isOpen = true;

  async beforeRouteEnter(_to: Route, _from: Route, next: NavigationGuardNext) {
    await currentScoutingStore.loadScoutingPlaces();
    await currentScoutingStore.loadScoutingAreas();
    next();
  }

  async beforeRouteUpdate(to: Route, _from: Route, next: NavigationGuardNext) {
    if (to.name === "scouting-poi" || to.name === "scouting-isocron") {
      this.detailsType = "scouting";
    }
    if (to.name === "scouting-poi-show") {
      this.detailsType = "poi";
    }
    if (to.name === "scouting-area-show") {
      this.detailsType = "area";
    }
    await currentScoutingStore.loadScoutingPlaces();
    await currentScoutingStore.loadScoutingAreas();
    next();
  }

  get showPoiDetails() {
    return this.detailsType === "poi";
  }

  get showAreaDetails() {
    return (
      this.detailsType === "area" && this.$route.name === "scouting-area-show"
    );
  }

  get showScoutingDetails() {
    return this.detailsType === "scouting" || !this.showAreaDetails;
  }

  @Ref("scoutingMap") readonly scoutingMap!: ScoutingMap;
  @Ref() readonly detailsView?: ScoutingDetails;

  get scoutingPlaces() {
    return currentScoutingStore.scoutingPlaces;
  }
  get scoutingAreas() {
    return currentScoutingStore.scoutingAreas;
  }

  initDetails() {
    if (
      this.$route.name === "scouting-poi" ||
      this.$route.name === "scouting-isocron"
    ) {
      this.detailsType = "scouting";
    }
    if (this.$route.name === "scouting-poi-show") {
      this.detailsType = "poi";
    }
    if (this.$route.name === "scouting-area-show") {
      this.detailsType = "area";
    }
  }

  subscribe() {
    StoreSubscriber.subscribe(
      "currentScouting/updateScoutingPlace",
      this.onScoutingPlaceUpdated.bind(this)
    );
    StoreSubscriber.subscribe(
      "currentScouting/$updateSearchScoutingPlace",
      this.onScoutingPlaceUpdated.bind(this)
    );
    StoreSubscriber.subscribe(
      "currentScouting/$updateSearchScoutingArea",
      this.onScoutingAreaUpdated.bind(this)
    );
    StoreSubscriber.subscribe(
      "currentScouting/$centerOnMarker",
      this.onCenterOnMarker.bind(this)
    );
    StoreSubscriber.subscribe(
      "currentScouting/$centerOnArea",
      this.onCenterOnArea.bind(this)
    );
    StoreSubscriber.subscribe(
      "currentScouting/removeScoutingPlace",
      this.onScoutingPlaceRemoved.bind(this)
    );
    StoreSubscriber.subscribe(
      "currentScouting/removeScoutingArea",
      this.onScoutingAreaRemoved.bind(this)
    );
    StoreSubscriber.subscribe(
      "currentScouting/$centerOnMarkers",
      this.onCenterOnMarkers.bind(this)
    );
    StoreSubscriber.subscribe(
      "currentScouting/$centerOnAllObjects",
      this.onCenterOnAllObject.bind(this)
    );
    StoreSubscriber.subscribe(
      "currentScouting/$addSearchScoutingPlaces",
      this.onSearchScoutingPlacesAdded.bind(this)
    );
    StoreSubscriber.subscribe(
      "currentScouting/$addSearchScoutingAreas",
      this.onSearchScoutingAreasAdded.bind(this)
    );
    StoreSubscriber.subscribe(
      "currentScouting/$setSearchScoutingAreas",
      this.onSearchScoutingAreasSet.bind(this)
    );
    StoreSubscriber.subscribe(
      "currentScouting/$clearMarkers",
      this.onClearMarkers.bind(this)
    );
    StoreSubscriber.subscribe(
      "currentScouting/$setSearchScoutingPlaces",
      this.onSearchScoutingPlacesSet.bind(this)
    );
    StoreSubscriber.subscribe(
      "currentScouting/$saveScouting",
      this.onSaveScouting.bind(this)
    );
    StoreSubscriber.subscribe(
      "currentScouting/updateClientScoutingPlaces",
      this.onUpdateClientScoutingPlaces.bind(this)
    );
  }

  onSaveScouting() {
    this.detailsView?.open();
  }

  onScoutingPlaceUpdated(payload: ScoutingPlace) {
    this.scoutingMap?.updateMarker(payload);
  }

  onScoutingAreaUpdated(payload: ScoutingArea) {
    this.scoutingMap?.updateArea(payload);
  }

  onClearMarkers() {
    this.scoutingMap?.clearMarkers();
  }

  onSearchScoutingPlacesAdded(payload: ScoutingPlace[]) {
    this.updateMarkers(payload, false);
  }

  onSearchScoutingAreasAdded(payload: ScoutingArea[]) {
    this.updateScoutingAreas(payload, true);
  }

  onSearchScoutingPlacesSet(payload: ScoutingPlace[]) {
    this.updateMarkers(payload);
  }

  onSearchScoutingAreasSet(payload: ScoutingPlace[]) {
    this.scoutingMap?.centerAllScoutingObjects();
  }

  onUpdateClientScoutingPlaces() {
    const scoutingPlaces: ScoutingPlace[] = this.scoutingPlaces;
    for (let scoutingPlace of scoutingPlaces) {
      scoutingPlace.highlighted = true;
    }
    this.updateMarkers(scoutingPlaces);
  }

  onCenterOnMarker(payload: ScoutingPlace) {
    this.scoutingMap?.centerOnPlace(payload);
  }

  onCenterOnArea(payload: ScoutingArea) {
    this.scoutingMap?.centerOnArea(payload);
  }

  onCenterOnAllObject() {
    this.scoutingMap?.centerAllScoutingObjects();
  }

  onScoutingPlaceRemoved(id: string) {
    this.scoutingMap?.removeMarker(id);
    this.scoutingMap?.centerAllScoutingObjects();
  }

  onScoutingAreaRemoved(id: string) {
    this.scoutingMap?.removeArea(id);
    this.scoutingMap?.centerAllScoutingObjects();
  }

  @Watch("scoutingPlaces")
  onScoutingPlaceChanged(values: ScoutingPlace[]) {
    for (const place of values) {
      place.highlighted = true;
      this.scoutingMap.addMarker(place);
    }
  }

  @Watch("scoutingAreas")
  onScoutingAreaChanged(values: ScoutingArea[]) {
    for (const area of values) {
      area.highlighted = true;
      this.scoutingMap.addArea(area);
    }
  }

  get scriptUrl() {
    return `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_API_KEY}&libraries=places&language=it`;
  }

  async loadGoogleMaps() {
    if (!window.google?.maps?.places) {
      const plugin = document.createElement("script");
      plugin.setAttribute("src", this.scriptUrl);
      plugin.async = true;
      document.head.appendChild(plugin);
      await new Promise((resolve) => (plugin.onload = resolve));
    }
    this.googleMapsLoaded = true;
    this.initView();
  }

  async mounted() {
    await this.loadGoogleMaps();
    this.initDetails();
    if (this.scoutingPlaces?.length !== 0) {
      this.updateMarkers(this.scoutingPlaces);
    }
    if (this.scoutingAreas?.length !== 0) {
      this.updateScoutingAreas(this.scoutingAreas);
    }

    this.scoutingMap?.centerAllScoutingObjects();
  }

  onCenterOnMarkers() {
    this.scoutingMap?.centerAllScoutingObjects();
  }

  initView() {
    this.subscribe();
  }

  private updateMarkers(points: ScoutingPlace[], clear = true) {
    if (clear) {
      this.scoutingMap?.clearMarkers();
    }
    for (const place of points) {
      this.scoutingMap?.addMarker(place);
    }
    this.scoutingMap?.centerAllScoutingObjects();
  }

  private updateScoutingAreas(areas: ScoutingArea[], clear = true) {
    if (clear) {
      this.scoutingMap?.clearMarkers();
    }
    for (const area of areas) {
      this.scoutingMap?.addArea(area);
    }
    this.scoutingMap?.centerOnAreas();
  }

  get scouting() {
    return currentScoutingStore.scouting;
  }
  async toggle() {
    this.isOpen = !this.isOpen;
    this.$nextTick();
    this.scoutingMap?.centerOnPlaces(currentScoutingStore.scoutingPlaces);
  }
}
